// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KtAm","productName":"Table_productName__ko_74"};